export const Types = {
  SAVE_LIST_GOLD_PRICE: "SAVE_LIST_GOLD_PRICE",
  SAVE_LIST_GOLD: "SAVE_LIST_GOLD",
  SAVE_ALL_GOLD_PRICE: "SAVE_ALL_GOLD_PRICE",
  SAVE_GOLD_GROUP: "SAVE_GOLD_GROUP",
  SAVE_REFERENCE_TAB: "SAVE_REFERENCE_TAB",
  SAVE_REFERENCE_ITEM: "SAVE_REFERENCE_ITEM",
  SAVE_USD_REFERENCE_ITEM: "SAVE_USD_REFERENCE_ITEM",
  SAVE_GOLD_OFFICIAL: "SAVE_GOLD_OFFICIAL",
  SAVE_HISTORY_CRAWL_GOLD: "SAVE_HISTORY_CRAWL_GOLD",
  SAVE_USD_OFFICIAL: "SAVE_USD_OFFICIAL",
  SAVE_HISTORY_CRAWL_USD: "SAVE_HISTORY_CRAWL_USD",
  SAVE_USD_REFERENCE_TAB: "SAVE_USD_REFERENCE_TAB",
  SAVE_GOLD_HANA_PRICE: "SAVE_GOLD_HANA_PRICE",
  SAVE_HISTORY_GOLD_HANA: "SAVE_HISTORY_GOLD_HANA",
};
